import React from 'react';
import { Alert, Button } from '@mui/material';

// Shared by SmartSortSection/AddPhotosSection/the attendee "Submit Photos"
// section (EventPage.js) and UploadLinkPage.js - all render this exact same
// "resuming a native background job" notice once a resumeJob (from
// useNativeUploadObserver, or the legacy listIncompleteJobs check for
// attendee-submit) is found for this event. `onCancel` is left to the caller
// since each site has its own cancel side effects (nativeUploadService.cancelJob,
// sometimes also cancelling grouping server-side) - this component only owns
// the copy/layout. Omitting `onCancel` renders the banner with no action
// button, matching the attendee-submit site (which has never offered a cancel
// button here).
export default function ResumeUploadBanner({ job, label = 'an upload', onCancel, sx = { mb: 1.5, py: 0.5 } }) {
  if (!job) return null;
  return (
    <Alert
      severity="info"
      sx={sx}
      action={onCancel ? <Button size="small" color="error" onClick={onCancel}>Cancel</Button> : undefined}
    >
      Resuming {label} from before you closed the app: {job.completedFiles}/{job.totalFiles} photos uploaded so far - it's continuing in the background.
    </Alert>
  );
}
